import { Fragment as _Fragment, jsx as _jsx } from "react/jsx-runtime";
import { useMemo, useState, useEffect } from 'react';
import { EventEmitter } from '@ciceksepeti/cs-event-emitter';
import { ModuleLoader, Fragments } from '@ciceksepeti/cs-module-loader';
import { NoData } from '@ciceksepeti/cs-no-data';
import '@ciceksepeti/cs-no-data/styles.css';
import Events from '@constants/events';
import { useCommons } from '@hooks/use-commons';
import { useResponsive } from '@hooks/use-responsive';
import styles from './styles.module.scss';
var Fragment = function (props) {
    var scope = props.scope, _a = props.skeleton, skeleton = _a === void 0 ? null : _a, _b = props.skeletonMobile, skeletonMobile = _b === void 0 ? null : _b, _c = props.section, section = _c === void 0 ? false : _c;
    var _d = useState(false), isTimeout = _d[0], setIsTimeout = _d[1];
    var _e = useState(''), notFoundMessage = _e[0], setNotFoundMessage = _e[1];
    var isMobileDevice = useResponsive().isMobileDevice;
    var variables = useCommons().variables;
    var handleTimeoutError = function (error) {
        var config = error.config;
        var _a = config.custom, customConfig = _a === void 0 ? {} : _a;
        var _b = customConfig.shouldTimeout, shouldTimeout = _b === void 0 ? true : _b;
        if (shouldTimeout) {
            setIsTimeout(true);
        }
    };
    var handleNotFoundError = function (error) {
        var response = error.response, config = error.config;
        var _a = config.custom, customConfig = _a === void 0 ? {} : _a;
        var _b = customConfig.shouldNoData, shouldNoData = _b === void 0 ? true : _b;
        if (shouldNoData) {
            var data = response.data;
            var _c = data.message, message = _c === void 0 ? '' : _c;
            setNotFoundMessage(message);
        }
    };
    useEffect(function () {
        if (section) {
            var eventEmitter_1 = new EventEmitter();
            eventEmitter_1.subscribe(Events.TIMEOUT, handleTimeoutError);
            eventEmitter_1.subscribe(Events.NOT_FOUND, handleNotFoundError);
            return function () {
                eventEmitter_1.unsubscribe(Events.TIMEOUT, handleTimeoutError);
                eventEmitter_1.unsubscribe(Events.NOT_FOUND, handleNotFoundError);
            };
        }
    }, [section]);
    var handleRefreshButtonClick = function () {
        window.location.reload();
    };
    var skeletonProp = _jsx(_Fragment, {});
    if (skeleton) {
        if (skeleton && skeletonMobile) {
            skeletonProp = isMobileDevice ? skeletonMobile : skeleton;
        }
        else {
            skeletonProp = skeleton;
        }
    }
    var fragment = useMemo(function () {
        return Fragments.get(scope);
    }, [scope]);
    return (_jsx(_Fragment, { children: isTimeout && section ? (_jsx(NoData, { className: styles.noData, content: "Bir sorun olu\u015Ftu. Sayfay\u0131 yeniden y\u00FCklemeyi deneyin.", iconProps: {
                iconName: 'icon-face-sad-sweat'
            }, buttonProps: {
                children: 'Yeniden Yükle',
                dimension: isMobileDevice ? 'small' : 'large',
                onClick: handleRefreshButtonClick
            } })) : notFoundMessage && section ? (_jsx(NoData, { className: styles.noData, content: notFoundMessage, iconProps: {
                iconName: 'icon-face-sad-sweat'
            } })) : (_jsx(ModuleLoader, { skeleton: skeletonProp, params: { variables: variables }, system: {
                url: fragment.url,
                scope: fragment.scope,
                module: fragment.module
            } })) }));
};
export default Fragment;
